import { render, staticRenderFns } from "./LaboratoryDetail.vue?vue&type=template&id=12af6bb9&scoped=true"
import script from "./LaboratoryDetail.vue?vue&type=script&lang=js"
export * from "./LaboratoryDetail.vue?vue&type=script&lang=js"
import style0 from "./LaboratoryDetail.vue?vue&type=style&index=0&id=12af6bb9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12af6bb9",
  null
  
)

export default component.exports